/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartItem_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItems_viewer$ref: FragmentReference;
export type CartItems_viewer = {|
  +$fragmentRefs: CartItem_viewer$ref,
  +$refType: CartItems_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartItems_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartItem_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '2ef03eeacfccef534e66e3816cb2e940';
module.exports = node;
